module.exports = __webpack_public_path__ + "static/img/gara.2dcff59.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/gara.jpg
// module id = 471
// module chunks = 11